import { TableHeader } from '@vizit/atoms';
import * as React from 'react';

/**
 * Header component for the Users table
 * Displays a single column for email addresses
 */
const UsersTableHeader = React.memo(() => {
  return (
    <TableHeader>
      <TableHeader.Column isRowHeader className="w-full">
        Email Address
      </TableHeader.Column>
    </TableHeader>
  );
});

export { UsersTableHeader };
